module.exports = __webpack_public_path__ + "img/Coupe_Back_Side_Left.929f2d51.svg";